import Seo from "@/components/Seo";
import LandingHeader from "@/components/landing/LandingHeader";
import HeroSection from "@/components/landing/HeroSection";
import TrustBar from "@/components/landing/TrustBar";
import RegistryCounter from "@/components/landing/RegistryCounter";
import ProblemSection from "@/components/landing/ProblemSection";
import StolenSection from "@/components/landing/StolenSection";
import RegistrySection from "@/components/landing/RegistrySection";
import PassportPreviewSection from "@/components/landing/PassportPreviewSection";
import AudienceSection from "@/components/landing/AudienceSection";
import ExploreSection from "@/components/landing/ExploreSection";
import FounderSection from "@/components/landing/FounderSection";
import PhysicalPassportSection from "@/components/landing/PhysicalPassportSection";
import FinalCtaSection from "@/components/landing/FinalCtaSection";
import LandingFooter from "@/components/landing/LandingFooter";
import { REGISTER_PATH } from "@/lib/routes";

export default function LandingPage() {
  const registerTo = REGISTER_PATH;

  return (
    <div
      id="top"
      className="min-h-screen surface-dial text-ink font-body overflow-x-hidden"
    >
      <Seo description="Provena Registry : le registre de confiance pour les montres de luxe. Déclarez les montres volées, consultez l'historique de propriété et protégez la provenance de votre collection." />
      <LandingHeader />
      <HeroSection registerTo={registerTo} />
      <TrustBar />
      <RegistryCounter />
      <ProblemSection registerTo={registerTo} />
      <StolenSection />
      <RegistrySection registerTo={registerTo} />
      <PassportPreviewSection registerTo={registerTo} />
      <AudienceSection registerTo={registerTo} />
      <ExploreSection />
      <FounderSection registerTo={registerTo} />
      <PhysicalPassportSection />
      <FinalCtaSection registerTo={registerTo} />
      <LandingFooter />
    </div>
  );
}
